export default __webpack_public_path__ + "assets/images/3eb15755eeecbd5cb68ca562878c3fe8.jpg";